import { newAddress } from '../../global/helpers';
import { AccountData, InfluencerLevel, MetaReferrer, UserModel, UserModelRefDisplayName } from './user.models';

export function buildAnonymousUser(uid?: string) {
  return {
    id: null,
    isAnonymous: true,
    photoURL: './assets/images/blank-profile.png',
    displayName: ' ', // Usuario desconocido
    uid
  };
}

export function buildUserWithoutUid() {
  return {
    id: null,
    photoURL: './assets/images/blank-profile.png',
    displayName: ' ', // Usuario desconocido
  };
}

export function toUserRefDisplayName(user: UserModel): UserModelRefDisplayName {
  return {
    id: user.id,
    displayName: user.displayName
  };
}

export function createMetaReferrer(): MetaReferrer {
  return {
    accpetanceId: null,
    userId: null,
    name: null,
    taxId: null,
    address: newAddress()
  };
}

export function convertToMetaReferrer(_value: any, userId: string): MetaReferrer {
  const metaReferrer: MetaReferrer = {
    accpetanceId: null,
    userId: userId,
    name: _value.name,
    taxId: _value.taxId,
    address: {
      recipient: _value.name,
      street: _value.street,
      number: _value.number,
      floor: _value.floor,
      addressLine1: _value.addressLine1,
      city: _value.city,
      province: _value.province,
      provinceId: _value.provinceId,
      postalCode: _value.postalCode,
      country: "Spain",
      phone: _value.phone,
      taxId: _value.taxId,
    },
  };
  return metaReferrer;
}

export function getUserAccountData(user: UserModel): AccountData {
  return {
    displayName: user.displayName,
    email: user.email,
    phoneNumber: user.phoneNumber
  };
}

/**
 * Defines the influencer levels based on the number of coupon uses, along with their associated properties such as
 * images, labels, and messages. Each level has a minimum and maximum number of uses, an image to represent the level,
 * a label for display, a message describing the benefits of the level, and a flag indicating whether the level includes
 * a coupon.
 */
export const INFLUENCER_LEVELS: InfluencerLevel[] = [
  {
    id: 'pendiente',
    minimumUses: 0,
    maximumUses: 9,
    image: 'assets/icon/embajador_hueco.svg',
    label: 'F',
    animatedImage: false,
    msg: 'Aún no tienes ningún cupón asignado',
    coupon: false
  },
  {
    id: 'tipo C',
    minimumUses: 10,
    maximumUses: 29,
    image: 'assets/icon/embajador_bronce.svg',
    label: 'C+',
    animatedImage: true,
    msg: '10€ de descuento y envío gratuito',
    coupon: true
  },
  {
    id: 'tipo B',
    minimumUses: 30,
    maximumUses: 99,
    image: 'assets/icon/embajador_plata.svg',
    label: 'B',
    animatedImage: true,
    msg: '15€ de descuento y envío gratuito',
    coupon: true
  },
  {
    id: 'tipo A',
    minimumUses: 100,
    image: 'assets/icon/embajador_oro.svg',
    label: 'A+',
    animatedImage: true,
    msg: '20€ de descuento y envío gratuito',
    coupon: true
  }
];

/**
 * Finds the influencer level based on the usage count.
 * @param usageCount The number of times the coupon has been used.
 * @param levels The array of influencer levels to search through.
 */
export function findInfluencerLevel(usageCount: number, levels: InfluencerLevel[] = INFLUENCER_LEVELS): InfluencerLevel {
  return levels.find(inf => usageCount >= inf.minimumUses && (usageCount <= inf.maximumUses || !inf.maximumUses));
}

/**
 * Marks influencer levels as enabled up to the current level (inclusive) and disabled for the rest.
 * @param levels The array of influencer levels.
 * @param currentLevelId The ID of the current influencer level.
 * @returns An array of influencer levels with an added `enabled` property indicating if the level is enabled.
 */
export function markInfluencerLevelsUpTo(levels: InfluencerLevel[], currentLevelId: string): (InfluencerLevel & { enabled: boolean; })[] {
  const result: (InfluencerLevel & { enabled: boolean; })[] = [];
  for (const level of levels) {
    result.push({ ...level, enabled: true });
    if (level.id === currentLevelId) {
      break;
    }
  }
  for (let i = result.length; i < levels.length; i++) {
    result.push({ ...levels[i], enabled: false });
  }
  return result;
}
